import React, { Component } from 'react';
import { Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { TopHeader, Logout } from '../../common';

class TopNav extends Component {
  render() {
    const { user, dispatch, websites, website, location } = this.props;

    const pathname = get(location, 'pathname');

    const title = ((websites.data || []).filter(e => e.slug === website.slug)[0] || {}).name || 'Websites';

    const sites = websites.data || [];

    const navLeft = (
      <Nav className="navbar-top-links">
        <NavDropdown eventKey={1} title={title} id="basic-nav-dropdown" href="javascript:void(0);">
          {sites.map((w, i) => {
            const path = `/publisher/home/websites/${w.slug}/dashboard`;
            return (
              <MenuItem key={`website-${i}`} href="javascript:void(0);" onClick={() => dispatch(push(path))}>
                {w.name}
              </MenuItem>
            );
          })}
          {pathname !== '/publisher/websites' ? (
            <MenuItem href="javascript:void(0);" onClick={() => dispatch(push('/publisher/home/websites'))}>
              All Websites
            </MenuItem>
          ) : null}
        </NavDropdown>
      </Nav>
    );

    const navRight = (
      <Nav pullRight className="navbar-top-links">
        <NavDropdown eventKey={1} title={user.name || 'Me'} id="basic-nav-dropdown" href="javascript:void(0);">
          <MenuItem href="javascript:void(0);" onClick={() => dispatch(push('/publisher/home/settings'))}>
            User Settings
          </MenuItem>
          {/* <MenuItem
            href='javascript:void(0);'
            onClick={() => dispatch(push('/publisher/home/cnames'))}
          >
            CNAMEs
          </MenuItem> */}
          <MenuItem href="javascript:void(0);" onClick={() => dispatch(push('/publisher/home/billing'))}>
            Billing
          </MenuItem>
          {user.isAdmin ? (
            <MenuItem href="javascript:void(0);" onClick={() => dispatch(push('/admin'))}>
              Admin
            </MenuItem>
          ) : null}
          <Logout />
        </NavDropdown>
      </Nav>
    );

    return (
      <TopHeader sideBtn>
        {sites.length > 0 && navLeft}
        {navRight}
      </TopHeader>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    user,
    publisher: { websites },
  } = state;
  const { website } = ownProps;

  return {
    user: user.data,
    websites: websites.data,
    website,
  };
};

export default connect(mapStateToProps)(TopNav);
